var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "red-packet-setting-container" },
    [
      _c(
        "el-form",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          ref: "form",
          staticStyle: { "margin-bottom": "200px" },
          attrs: { "label-width": "163px", model: _vm.form, rules: _vm.rules },
        },
        [
          _c(
            "el-card",
            { staticClass: "box-card", attrs: { type: "card" } },
            [
              _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                _vm._v("活动信息"),
              ]),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "活动标题：", prop: "title" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入活动标题" },
                    model: {
                      value: _vm.form.title,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "title", $$v)
                      },
                      expression: "form.title",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "活动副标题：", prop: "subtitle" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入活动副标题" },
                    model: {
                      value: _vm.form.subtitle,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "subtitle", $$v)
                      },
                      expression: "form.subtitle",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "活动时间：", prop: "activityTime" } },
                [
                  _c("el-date-picker", {
                    attrs: {
                      type: "datetimerange",
                      "range-separator": "至",
                      "start-placeholder": "开始日期",
                      "end-placeholder": "结束日期",
                      "default-time": ["00:00:00", "23:59:59"],
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                    },
                    model: {
                      value: _vm.form.activityTime,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "activityTime", $$v)
                      },
                      expression: "form.activityTime",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "库存数量：", prop: "stock" } },
                [
                  _c("el-input-number", {
                    attrs: {
                      placeholder: "请输入库存数量",
                      min: 1,
                      max: 999999,
                    },
                    model: {
                      value: _vm.form.stock,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "stock", $$v)
                      },
                      expression: "form.stock",
                    },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "stock-tip" }, [
                    _vm._v(
                      "(发起者库存+助力者库存：" +
                        _vm._s(_vm.totalStockTip) +
                        ")"
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "是否启动：", prop: "enabled" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.form.enabled,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "enabled", $$v)
                        },
                        expression: "form.enabled",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v(" 启动 "),
                      ]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v(" 未启动 "),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "邀请人数：", prop: "inviteCount" } },
                [
                  _c("el-input-number", {
                    attrs: { placeholder: "请输入邀请人数", min: 1, max: 10 },
                    model: {
                      value: _vm.form.inviteCount,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "inviteCount", $$v)
                      },
                      expression: "form.inviteCount",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "活动城市：", prop: "cityRestriction" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.form.cityRestriction,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "cityRestriction", $$v)
                        },
                        expression: "form.cityRestriction",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v(" 无限制 "),
                      ]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 2 } }, [
                        _vm._v(" 仅gaga所在城市 "),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.form.cityRestriction === 2
                ? _c(
                    "el-form-item",
                    { attrs: { label: "活动城市：", prop: "cityIds" } },
                    [
                      _c(
                        "el-checkbox-group",
                        {
                          model: {
                            value: _vm.form.cityIds,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "cityIds", $$v)
                            },
                            expression: "form.cityIds",
                          },
                        },
                        _vm._l(_vm.gagaAreaList, function (item) {
                          return _c(
                            "el-checkbox",
                            {
                              key: item.value,
                              attrs: { label: item.value, border: "" },
                            },
                            [_vm._v(_vm._s(item.label))]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-card",
            { staticClass: "box-card", attrs: { type: "card" } },
            [
              _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                _vm._v("页面设置"),
              ]),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "活动页头图：", prop: "headerImage" } },
                [
                  _c("red-packet-upload-img", {
                    attrs: {
                      "data-imgurl": _vm.form.headerImage,
                      "image-access-domain": _vm.imageAccessDomain,
                      limit: 2,
                      "limit-unit": "MB",
                    },
                    model: {
                      value: _vm.form.headerImage,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "headerImage", $$v)
                      },
                      expression: "form.headerImage",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "活动页背景色：", prop: "bgColor" } },
                [
                  _c("el-color-picker", {
                    model: {
                      value: _vm.form.bgColor,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "bgColor", $$v)
                      },
                      expression: "form.bgColor",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: { label: "第三层背景色：", prop: "thirdLayerBgColor" },
                },
                [
                  _c("el-color-picker", {
                    model: {
                      value: _vm.form.thirdLayerBgColor,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "thirdLayerBgColor", $$v)
                      },
                      expression: "form.thirdLayerBgColor",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "红包卡片前景色：",
                    prop: "redPacketCardFgColor",
                  },
                },
                [
                  _c("el-color-picker", {
                    model: {
                      value: _vm.form.redPacketCardFgColor,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "redPacketCardFgColor", $$v)
                      },
                      expression: "form.redPacketCardFgColor",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "其他卡片前景色：",
                    prop: "otherCardFgColor",
                  },
                },
                [
                  _c("el-color-picker", {
                    model: {
                      value: _vm.form.otherCardFgColor,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "otherCardFgColor", $$v)
                      },
                      expression: "form.otherCardFgColor",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "卡片标题色：", prop: "cardTitleColor" } },
                [
                  _c("el-color-picker", {
                    model: {
                      value: _vm.form.cardTitleColor,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "cardTitleColor", $$v)
                      },
                      expression: "form.cardTitleColor",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "剩余红包数字颜色：",
                    prop: "redPacketNumColor",
                  },
                },
                [
                  _c("el-color-picker", {
                    model: {
                      value: _vm.form.redPacketNumColor,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "redPacketNumColor", $$v)
                      },
                      expression: "form.redPacketNumColor",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "按钮文字色：", prop: "btnTextColor" } },
                [
                  _c("el-color-picker", {
                    model: {
                      value: _vm.form.btnTextColor,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "btnTextColor", $$v)
                      },
                      expression: "form.btnTextColor",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "按钮背景色：", prop: "btnBgColor" } },
                [
                  _c("el-color-picker", {
                    model: {
                      value: _vm.form.btnBgColor,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "btnBgColor", $$v)
                      },
                      expression: "form.btnBgColor",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "进度icon：", prop: "progressIcon" } },
                [
                  _c("red-packet-upload-img", {
                    attrs: {
                      "image-access-domain": _vm.imageAccessDomain,
                      limit: 500,
                      "limit-unit": "KB",
                    },
                    model: {
                      value: _vm.form.progressIcon,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "progressIcon", $$v)
                      },
                      expression: "form.progressIcon",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "进度条切图：", prop: "progressBarImage" } },
                [
                  _c("red-packet-upload-img", {
                    attrs: {
                      "image-access-domain": _vm.imageAccessDomain,
                      limit: 500,
                      "limit-unit": "KB",
                    },
                    model: {
                      value: _vm.form.progressBarImage,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "progressBarImage", $$v)
                      },
                      expression: "form.progressBarImage",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "助力人背景图：",
                    prop: "helperBackgroundImage",
                  },
                },
                [
                  _c("red-packet-upload-img", {
                    attrs: {
                      "image-access-domain": _vm.imageAccessDomain,
                      limit: 5,
                      "limit-unit": "MB",
                    },
                    model: {
                      value: _vm.form.helperBackgroundImage,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "helperBackgroundImage", $$v)
                      },
                      expression: "form.helperBackgroundImage",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "分享卡片图：", prop: "shareCardImage" } },
                [
                  _c("red-packet-upload-img", {
                    attrs: {
                      "image-access-domain": _vm.imageAccessDomain,
                      limit: 5,
                      "limit-unit": "MB",
                    },
                    model: {
                      value: _vm.form.shareCardImage,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "shareCardImage", $$v)
                      },
                      expression: "form.shareCardImage",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "海报图：", prop: "posterImage" } },
                [
                  _c("red-packet-upload-img", {
                    attrs: {
                      "image-access-domain": _vm.imageAccessDomain,
                      limit: 5,
                      "limit-unit": "MB",
                    },
                    model: {
                      value: _vm.form.posterImage,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "posterImage", $$v)
                      },
                      expression: "form.posterImage",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "领取红包弹窗背景图：",
                    prop: "redPacketPopupBg",
                  },
                },
                [
                  _c("red-packet-upload-img", {
                    attrs: {
                      "image-access-domain": _vm.imageAccessDomain,
                      limit: 5,
                      "limit-unit": "MB",
                    },
                    model: {
                      value: _vm.form.redPacketPopupBg,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "redPacketPopupBg", $$v)
                      },
                      expression: "form.redPacketPopupBg",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "剩余红包数字背景图：",
                    prop: "redPacketNumBgImg",
                  },
                },
                [
                  _c("red-packet-upload-img", {
                    attrs: {
                      "image-access-domain": _vm.imageAccessDomain,
                      limit: 5,
                      "limit-unit": "MB",
                    },
                    model: {
                      value: _vm.form.redPacketNumBgImg,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "redPacketNumBgImg", $$v)
                      },
                      expression: "form.redPacketNumBgImg",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "活动规则说明：", prop: "ruleText" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      autosize: { minRows: 4, maxRows: 6 },
                      "show-word-limit": "",
                      placeholder: "请输入活动规则说明",
                    },
                    model: {
                      value: _vm.form.ruleText,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "ruleText", $$v)
                      },
                      expression: "form.ruleText",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-card",
            { staticClass: "box-card", attrs: { type: "card" } },
            [
              _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                _vm._v("发起人规则&奖励"),
              ]),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "发起人会员等级：",
                    prop: "initiatorRestriction",
                  },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.form.initiatorRestriction,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "initiatorRestriction", $$v)
                        },
                        expression: "form.initiatorRestriction",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v(" 全部会员 "),
                      ]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 2 } }, [
                        _vm._v(" 按等级 "),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.form.initiatorRestriction === 2
                ? _c(
                    "el-form-item",
                    {
                      attrs: { label: "会员等级：", prop: "initiatorGradeIds" },
                    },
                    [
                      _c(
                        "el-checkbox-group",
                        {
                          model: {
                            value: _vm.form.initiatorGradeIds,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "initiatorGradeIds", $$v)
                            },
                            expression: "form.initiatorGradeIds",
                          },
                        },
                        _vm._l(_vm.memberLevelList, function (item) {
                          return _c(
                            "el-checkbox",
                            {
                              key: "initiator-" + item.value,
                              attrs: { label: item.value },
                            },
                            [_vm._v(_vm._s(item.label))]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "发起人奖励：", prop: "initiatorPrize" } },
                [
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: false,
                          expression: "false",
                        },
                      ],
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.form.initiatorPrize) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.form.initiatorPrize, function (item, idx) {
                    return _c(
                      "red-packet-create-prize-pane",
                      {
                        key: "initiator-coupon-" + idx,
                        model: {
                          value: _vm.form.initiatorPrize[idx],
                          callback: function ($$v) {
                            _vm.$set(_vm.form.initiatorPrize, idx, $$v)
                          },
                          expression: "form.initiatorPrize[idx]",
                        },
                      },
                      [
                        _c(
                          "template",
                          { slot: "action" },
                          [
                            _vm.form.initiatorPrize.length - 1 === idx
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.addInitiatorPrize(idx)
                                      },
                                    },
                                  },
                                  [_vm._v("新增")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.form.initiatorPrize.length > 1
                              ? _c(
                                  "el-button",
                                  {
                                    staticStyle: { color: "red" },
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.removeInitiatorPrize(idx)
                                      },
                                    },
                                  },
                                  [_vm._v("删除")]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      2
                    )
                  }),
                ],
                2
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-card",
            { staticClass: "box-card", attrs: { type: "card" } },
            [
              _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                _vm._v("助力者规则&奖励"),
              ]),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "助力者会员等级：",
                    prop: "helperRestriction",
                  },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.form.helperRestriction,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "helperRestriction", $$v)
                        },
                        expression: "form.helperRestriction",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v(" 全部会员 "),
                      ]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 2 } }, [
                        _vm._v(" 按等级 "),
                      ]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 3 } }, [
                        _vm._v(" 新用户 "),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.form.helperRestriction === 2
                ? _c(
                    "el-form-item",
                    { attrs: { label: "会员等级：", prop: "helperGradeIds" } },
                    [
                      _c(
                        "el-checkbox-group",
                        {
                          model: {
                            value: _vm.form.helperGradeIds,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "helperGradeIds", $$v)
                            },
                            expression: "form.helperGradeIds",
                          },
                        },
                        _vm._l(_vm.memberLevelList, function (item) {
                          return _c(
                            "el-checkbox",
                            {
                              key: "helper-" + item.value,
                              attrs: { label: item.value },
                            },
                            [_vm._v(_vm._s(item.label))]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "助力者奖励：", prop: "helperPrize" } },
                [
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: false,
                          expression: "false",
                        },
                      ],
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.form.helperPrize) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.form.helperPrize, function (item, idx) {
                    return _c(
                      "red-packet-create-prize-pane",
                      {
                        key: "helper-coupon-" + idx,
                        model: {
                          value: _vm.form.helperPrize[idx],
                          callback: function ($$v) {
                            _vm.$set(_vm.form.helperPrize, idx, $$v)
                          },
                          expression: "form.helperPrize[idx]",
                        },
                      },
                      [
                        _c(
                          "template",
                          { slot: "action" },
                          [
                            _vm.form.helperPrize.length - 1 === idx
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.addHelperPrize(idx)
                                      },
                                    },
                                  },
                                  [_vm._v("新增")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.form.helperPrize.length > 1
                              ? _c(
                                  "el-button",
                                  {
                                    staticStyle: { color: "red" },
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.removeHelperPrize(idx)
                                      },
                                    },
                                  },
                                  [_vm._v("删除")]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      2
                    )
                  }),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticStyle: {
            position: "fixed",
            bottom: "100px",
            right: "100px",
            "z-index": "1000",
          },
        },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.submit } },
            [_vm._v("保存")]
          ),
          _vm._v(" "),
          _c("el-button", { on: { click: _vm.reset } }, [_vm._v("重置")]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }